import { useState } from 'react';
import { Box, Popover } from '@mui/material';
import { FiltersCTA } from './FiltersCTA';
import { Filters } from './Filters';

const FiltersPopover = () => {
  const [openFiltersPopover, setOpenFiltersPopover] = useState(false);
  const [anchorEl, setAnchorEl] = useState<(EventTarget & Element) | null>(null);

  const handlePopoverClose = () => {
    setAnchorEl(null);
    setOpenFiltersPopover(false);
  };

  return (
    <Box mt={1}>
      <FiltersCTA setOpenFiltersPopover={setOpenFiltersPopover} setPopoverAnchorEl={setAnchorEl} />
      <Popover
        id="listing-page-filters-popover"
        open={openFiltersPopover}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}>
        <Box width="559px" maxHeight="742px">
          <Filters setPopoverAnchorEl={setAnchorEl} setOpenFiltersPopover={setOpenFiltersPopover} />
        </Box>
      </Popover>
    </Box>
  );
};

export { FiltersPopover };
